<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-on="{ ...tooltip, ...dialog }"
            @click="setCurrentNotes"
            color="orange"
          ><v-icon>note</v-icon> </v-btn>
        </template>
        <span>Edit notes</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        <h2>Edit notes</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field
            v-model="noteText"
            label="note"
            prepend-icon="note"
            :rules="notesRules"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirmNoteChange"
            class="success mx-1 mt-3"
            :loading="loadingConfirm"
            ><v-icon>done</v-icon><span> Confirm change</span></v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    cartId: {
      type: String
    },
    notes: {
      type: String
    },
  },
  data() {
    return {
      noteText: "",
      notesRules: [
        v => !!v || "This field is required",
      ],
      loadingConfirm: false,
      loadingCancel: false,
      dialog: false
    };
  },
  methods: {
    setCurrentNotes() {
      this.noteText = this.notes
    },
    confirmNoteChange() {
      if (this.$refs.form.validate()) {
        this.loadingConfirm = true;
        cartApi
          .postAddPaymentNotes(this.cartId, this.noteText)
          .then(() => {
            this.loadingConfirm = false;
            this.dialog = false;
            this.$emit("noteChanged");
          });
      }
    }
  }
};
</script>
